import useFetchApi from "@/api/hooks/useFetchApi";
import BreadCrumb from "@/components/BreadCrumb";
import ServiceCard from "@/components/Cards/ServiceCard";
import Loader from "@/components/Loader/loader";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const Catalog: React.FC = () => {

    const { category } = useParams<{ category: string }>();
    const [targetPopulate, setTargetPopulate] = useState("677fc667d2c0311ca14f7f8c")
    const [breadcrumbChild, setBreadcrumbChild] = useState<string>("");

    useEffect(() => {
        if (category === "tanitim") {
            setTargetPopulate("677fc667d2c0311ca14f7f8c")
        }
        else if (category === "sds")
            setTargetPopulate("677f8d33d2c0311ca14f5cae")
        else if (category === "emniyet")
            setTargetPopulate("6780c918d572d534b33c1f6c")
        else {
            setTargetPopulate("677fc667d2c0311ca14f7f8c")
        }
    }, [category])

    const {
        data,
        isLoading,
        error
    } = useFetchApi({
        url: `/v1/main-module/677f8b60d2c0311ca14f57df/collection/${targetPopulate}/detail?list_related=true&module_populate=677f8d6bd2c0311ca14f5df4`,
        service: "CMS_PROC",
        options: {
            refreshInterval: 0,
            revalidateOnFocus: false,
        }
    })

    useEffect(() => {
        if (data && data.title) {
            setBreadcrumbChild(data.title);
        }
    }, [data])

    return (
        <>
            <BreadCrumb title="Katalog" parent="Katalog" child={breadcrumbChild} />
            <section className="ls section_padding_top_135 section_padding_bottom_90 columns_padding_25">
                <div className="container">
                    <div className="row columns_margin_bottom_40 services-row">
                        {!isLoading && data ? (
                            data.populated?.["Katalog İçerikler"]?.records?.map((record: any) => (
                                <ServiceCard
                                    key={record._id}
                                    data={{
                                        title: record.title,
                                        dosya: record.dosya,
                                        content: record.content,
                                    }}
                                    isLoading={false}
                                />
                            ))
                        ) : (
                            <p><Loader /></p>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};
export default Catalog;